import voucherTransformer from '../../transformers/voucher';
import axios from 'axios';

export default (payload) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .postForm(process.env.VUE_APP_API_ADMIN_LOCATION + 'vouchers', payload)
      .then(({ data }) => {
        let voucher = {};
        if (data.data) {
          voucher = voucherTransformer.fetch(data.data);
        }
        resolve(voucher);
      })
      .catch((error) => {
        reject(error);
      });
  });
  return promise;
};
